module.exports = __webpack_public_path__ + "img/h8.8c4d7477.png";